import { render, staticRenderFns } from "./Revocation.vue?vue&type=template&id=6bc0cb71&scoped=true&"
import script from "./Revocation.vue?vue&type=script&lang=ts&"
export * from "./Revocation.vue?vue&type=script&lang=ts&"
import style0 from "./Revocation.vue?vue&type=style&index=0&id=6bc0cb71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0cb71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VContainer,VSheet})
